import { ReactComponent as ArrowIcon } from 'assets/icons/arrow_short_right.svg'
import { ReactComponent as CheckIcon } from 'assets/icons/check.svg'
import { ReactComponent as DockIcon } from 'assets/icons/dock.svg'
import ResourceActionsCurriculum from 'pages/Classroom/components/CurriculumView/components/ResourceActionsCurriculum/ResourceActionsCurriculum'
import useCurriculumCardShort from './hooks/useCurriculumCardShort'
import s from './styles/CurriculumCardShort.module.scss'

export default function CurriculumCardShort({
	card,
	onViewAllSessions,
	onResourceClick,
	onTaskClick,
	onMarkComplete,
}) {
	const {
		grade,
		gradeStatus,
		gradeStatusLabel,
		progress,
		session,
		isCompleted,
		completedDateLabel,
		taskLabel,
		handleViewAllSessions,
		handleResourceClick,
		handleTaskClick,
		handleMarkComplete,
	} = useCurriculumCardShort({
		card,
		onViewAllSessions,
		onResourceClick,
		onTaskClick,
		onMarkComplete,
	})

	return (
		<article className={s.card}>
			<div className={s.header}>
				<div className={s.headerLeft}>
					<span className={s.gradeLabel}>Grade {grade}</span>
					<span
						className={[s.gradeBadge, s[`gradeBadge_${gradeStatus}`]]
							.filter(Boolean)
							.join(' ')}
					>
						{gradeStatusLabel}
					</span>
				</div>

				<div className={s.progress}>
					<div className={s.progress__track}>
						<div
							className={s.progress__fill}
							style={{ width: `${progress.percent}%` }}
						/>
					</div>
					<span className={s.progress__fraction}>
						{progress.completed}/{progress.total}
					</span>
				</div>
			</div>

			<h3 className={s.sessionTitle}>{session.title}</h3>

			<div className={s.resources}>
				<ResourceActionsCurriculum
					resources={session.resources}
					onResourceClick={handleResourceClick}
					emptyLabel="Resources coming soon..."
				/>
				<button type="button" className={s.taskBtn} onClick={handleTaskClick}>
					<DockIcon className={s.taskBtn__icon} />
					<span>{taskLabel}</span>
				</button>
			</div>

			<footer className={s.footer}>
				<button
					type="button"
					className={s.viewAllBtn}
					onClick={handleViewAllSessions}
				>
					<span>View all sessions</span>
					<ArrowIcon className={s.viewAllBtn__icon} />
				</button>

				{isCompleted ? (
					<div className={`${s.completeBtn} ${s.completeBtn_completed}`}>
						<span>Completed</span>
						{completedDateLabel ? (
							<span className={s.completeBtn__date}>{completedDateLabel}</span>
						) : null}
					</div>
				) : (
					<button
						type="button"
						className={`${s.completeBtn} ${s.completeBtn_mark}`}
						onClick={handleMarkComplete}
					>
						<span className={s.completeBtn__icon}>
							<CheckIcon />
						</span>
						<span>Mark Complete</span>
					</button>
				)}
			</footer>
		</article>
	)
}
